import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

//Actions
import * as ordersActions from '../../actions/ordersActions';

import OrdersInner from './ordersInner';

class WorkingOrders extends React.Component {
    componentDidMount() {
        const { actions } = this.props;
        actions.getOrders('workingOrders');
    }

    render() {
        const { user, actions } = this.props;

        return (
            <div style={{position: 'relative'}}>
                <h1>Your firm working orders</h1>
                <h3>These orders are currently LIVE in the system from your company.</h3>
                <h3>As a registered user, you may delete or update any of these orders below by clicking on it.</h3>
                {!user.isAdmin && !user.isSuperUser && user.userInfo.can_trade ?
                    <button className="button top-right" onClick={actions.deleteWorkingOrders}>Delete all</button>
                : null}
                <OrdersInner {...this.props} mode='edit'/>
            </div>

        )
    }
}

export default connect(
    state => ({
        orders: state.orders,
        user: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...ordersActions}, dispatch)
    })
)(WorkingOrders);



// WEBPACK FOOTER //
// ./source/screens/orders/workingOrders.js